import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { RcsbFvRow } from "../../RcsbFvRow/RcsbFvRow";
import { RowConfigFactory } from "../Utils/RowConfigFactory";
import uniqid from "uniqid";
export class AxisRow extends React.Component {
    render() {
        const rowId = uniqid("rcsbFvAxis_");
        const rowConfig = { displayType: "axis" /* RcsbFvDisplayTypes.AXIS */, trackId: rowId, boardId: this.props.boardId };
        return (_jsx("div", { children: _jsx(RcsbFvRow, { id: rowId, boardId: this.props.boardId, rowNumber: 0, rowConfigData: RowConfigFactory.getConfig(rowId, this.props.boardId, rowConfig, this.props.boardConfigData), xScale: this.props.xScale, selection: this.props.selection, contextManager: this.props.contextManager, renderSchedule: "fixed" }) }, rowId));
    }
}
